<mat-tree *ngIf="dataSource.data.length > 0" 
          style="background-color: transparent;" 
          [dataSource]="dataSource"
          [treeControl]="treeControl">
  <!--
  NODI FOGLIA
  -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle 
                matTreeNodePadding matTreeNodePaddingIndent="20"
                matRipple
                style="cursor: 'pointer'"
                [class.mat-elevation-z2]="node.id == routingDataService.selectedMenuNodeId"
                [ngStyle]="{'display': !node.hidden ? 'auto' : 'none',
                            'color': node.id == routingDataService.selectedMenuNodeId ? selectedItemFontColor : fontColor,
                            'background-color': node.id == routingDataService.selectedMenuNodeId ? selectedItemBgColor : null,
                            'cursor': !node.disabled ? 'pointer' : 'auto'}"
                (click)="menuClick(node)">
    <div class="layout horizontal middle space-between" style="width: 100%; padding-left: 6px;">
      <app-icon-label [iconId]="node.icon" [label]="node.label | translate"></app-icon-label>
      <button mat-icon-button disabled></button>
    </div>
  </mat-tree-node>
  <!--
  NODI NON FOGLIA
  -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" 
                matTreeNodeToggle
                matTreeNodePadding matTreeNodePaddingIndent="20"
                matRipple 
                style="cursor: 'pointer'"
                [ngStyle]="{'display': !node.hidden ? 'auto' : 'none',
                            'color': fontColor}">
    <div class="layout horizontal middle space-between" style="width: 100%; padding-left: 6px;">
      <app-icon-label [iconId]="node.icon" [label]="node.label | translate"></app-icon-label>
      <div class="layout horizontal center middle" style="height: 40px; width: 40px;">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
        </mat-icon>
      </div>
    </div>
  </mat-tree-node>
</mat-tree>
